import type { IFilterInstance } from "app/pages/sales-intelligence/modules/advanced-search-filtering/types/filterInstance";
import AppIosCategoryFilter from "app/pages/sales-intelligence/modules/find-apps-filters/components/filters/AppIosCategoryFilter/AppIosCategoryFilter";
import AppIosCategoryFilterResult from "app/pages/sales-intelligence/modules/find-apps-filters/components/filters/AppIosCategoryFilter/AppIosCategoryFilterResult";
import FindAppsCategoryFilter from "app/pages/sales-intelligence/modules/find-apps-filters/models/CategoryFilter/CategoryFilter";
import { AppsCategoryTypes } from "app/pages/sales-intelligence/modules/find-apps-filters/types/commonEnums";
import type { FindAppsDescriptionDto } from "app/pages/sales-intelligence/modules/find-apps-filters/types/description.dto";
import type { IAppsIosFiltersDto } from "app/pages/sales-intelligence/store/find-apps/types";

function createCategoryFilter(description: FindAppsDescriptionDto): IFilterInstance<IAppsIosFiltersDto> {
    return {
        key: "category",
        trackingName: "App Category",
        title: { key: "si.find_apps.filters.ios-category.title" },
        tooltipText: { key: "si.find_apps.filters.ios-category.tooltip" },
        filter: new FindAppsCategoryFilter({
            options: description?.iosCategory || {
                primaryCategories: [],
                types: [AppsCategoryTypes.All],
                categories: [],
            },
        }),
        filterView: AppIosCategoryFilter,
        filterResultView: AppIosCategoryFilterResult,
    };
}

export default createCategoryFilter;
